'use client';
export default function Loading() {
  return (
    <>
      <div className="w-[100vw] h-[100vh]">
        <svg className="loadingSVG">
          <circle cx="70" cy="70" r="70" className="loadingCircle">
          </circle>
        </svg>
      </div>
    </>
  );
}
